import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { KeyRound } from "lucide-react";

export default function ChangePassword() {
  const { user, setUser, logout } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next.length < 8) { setError("New password must be at least 8 characters"); return; }
    if (next !== confirm) { setError("Passwords don't match"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      const updated = { ...user, must_reset_password: false };
      setUser(updated);
      localStorage.setItem("pgm_user", JSON.stringify(updated));
      nav("/dashboard", { replace: true });
    } catch (err) {
      setError(err?.response?.data?.detail || "Failed to change password");
    } finally { setSaving(false); }
  };

  return (
    <div className="pgm-login-bg">
      <div className="pgm-reveal" style={{ width: "100%", maxWidth: 480 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 12, marginBottom: 18 }}>
          <div style={{ width: 56, height: 56, background: "var(--pgm-magenta)", display: "flex", alignItems: "center", justifyContent: "center", border: "1.5px solid var(--pgm-wine)" }}>
            <KeyRound size={26} color="var(--pgm-cream)" />
          </div>
        </div>
        <div className="pgm-card">
          <div className="pgm-micro">◆ Account security</div>
          <h2 className="pgm-display" style={{ fontSize: 28, marginBottom: 6 }}>Change your password</h2>
          {user?.must_reset_password && (
            <div className="pgm-callout" style={{ marginBottom: 14 }}>
              <strong>First login.</strong> Please change the temporary password your show owner shared.
            </div>
          )}
          <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <div><label className="pgm-label">Current password</label><input type="password" className="pgm-input" value={current} onChange={(e) => setCurrent(e.target.value)} required data-testid="cp-current" autoFocus /></div>
            <div><label className="pgm-label">New password (min 8 characters)</label><input type="password" className="pgm-input" value={next} onChange={(e) => setNext(e.target.value)} required data-testid="cp-new" /></div>
            <div><label className="pgm-label">Confirm new password</label><input type="password" className="pgm-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="cp-confirm" /></div>
            {error && <div className="pgm-callout" style={{ background: "var(--pgm-orange)", color: "var(--pgm-cream)" }} data-testid="cp-error">{error}</div>}
            <button className="pgm-btn" type="submit" disabled={saving} data-testid="cp-submit">{saving ? "Saving..." : "Update password"}</button>
            <button type="button" onClick={logout} className="pgm-btn pgm-btn-ghost" data-testid="cp-cancel">Sign out</button>
          </form>
        </div>
      </div>
    </div>
  );
}
